<template>
  <BaseModal :is-open="isOpen" :add-divider-to-footer="true">
    <template #title>
      パスワード再設定
    </template>
    <template #contents>
      <ErrorMessageArea
        :error-messages="errors"
        class="mb-4"
      />
      <div>
        <label>ID/氏名</label>
        <v-text-field
          :value="userIdAndName"
          variant="outlined"
          color="primary"
          class="w-100 bg-readonly-form"
          readonly
          hide-details
        />
      </div>
      <div class="mt-5">
        <label for="current-password">現在のパスワード</label>
        <PasswordInput
          id="current-password"
          v-model="passwordResetForm.currentPassword"
          :error="!!errors.currentPassword"
          maxlength="16"
        />
      </div>
      <div class="mt-5">
        <label for="new-password">新しいパスワード</label>
        <PasswordInput
          id="new-password"
          v-model="passwordResetForm.newPassword"
          :error="!!errors.newPassword"
          maxlength="16"
        />
        <div class="description">
          ※半角英大文字/小文字/数字/記号すべて含む8-16桁
        </div>
      </div>
      <div class="mt-5">
        <label for="new-password-confirmation">新しいパスワード【確認】</label>
        <PasswordInput
          id="new-password-confirmation"
          v-model="passwordResetForm.newPasswordConfirmation"
          :error="!!errors.newPasswordConfirmation"
          maxlength="16"
        />
        <div class="description">
          ※新しいパスワードと一致していること
        </div>
      </div>
    </template>
    <template #actionButtons>
      <CustomButton
        :disabled="isConfirmBtnDisabled"
        @click="resetPassword"
      >
        決定
      </CustomButton>
      <CustomButton
        class="mt-3 w-100"
        variant="text"
        @click="emits('canceled')"
      >
        キャンセル
      </CustomButton>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '../base/BaseModal.vue';
import CustomButton from '../../common/parts/CustomButton.vue';
import PasswordInput from '~/components/common/parts/PasswordInput.vue';
import ErrorMessageArea from '~/components/common/ErrorMessageArea.vue';

const DISPLAY_ID = 'C-09';

const emits = defineEmits<{
  confirmed: [];
  canceled: [];
}>();

const {
  isOpen,
  passwordResetForm,
  errors,
  isConfirmBtnDisabled,
  userIdAndName,
  resetPassword,
  open,
  close,
} = usePasswordResetModalLogic(
  DISPLAY_ID,
  emits,
);

defineExpose({
  open,
  close,
});
</script>

<style lang="scss" scoped>
label {
  font-weight: bold;
}

.description {
  font-size: 14px;
}
</style>
